<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="仮想ネットワーク情報"
  >
    <template v-slot:body="{ cancel }">
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  color="primary"
                  v-permission.config
                  @click="showNetworkModify"
                  class="mr-2"
                  >変更</v-btn
                >
                <v-btn
                  color="primary"
                  v-permission.config
                  @click="showNetworkDel"
                  >削除</v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="L2/L3"
                  :value="network.vnType"
                  class="mb-2"
                />
              </v-col>
              <v-col cols="12">
                <app-label-group
                  label="仮想ネットワーク(VN)名"
                  :value="network.vnName"
                  class="mb-2"
                />
              </v-col>
              <v-col cols="12">
                <app-label-group
                  label="VNコード"
                  :value="network.vnCode"
                  class="mb-2"
                />
              </v-col>
              <v-col cols="12" v-if="network.vnType === 'L2'" class="mb-2">
                <app-label-group
                  label="VLAN"
                  :value="
                    network.vlanIdType === 'SPECIFIED'
                      ? network.vlanId
                      : $filter.enumTo(network.vlanIdType, 'vlanIdType')
                  "
                />
              </v-col>
              <v-col cols="12">
                <app-label-group
                  label="利用可能VNコネクト数"
                  :value="`${network.upperLimitVnConnect}回線`"
                />
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type { VirtualNetworkEntity } from "@/apis/VirtualNetworkApi";
import VirtualNetworkEdit from "@/modals/virtualNetwork/VirtualNetworkEdit.vue";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "VirtualNetworkReference",
  props: {
    /** 仮想ネットワーク情報 */
    network: {
      type: Object as PropType<VirtualNetworkEntity>,
      required: true,
    },
    /** 仮想ネットワーク設定排他情報 */
    vnKeyId: {
      type: String as PropType<string>,
      required: true,
    },
  },
  methods: {
    /** 変更*/
    async showNetworkModify() {
      await this.$modal.show(VirtualNetworkEdit, {
        virtualNetwork: this.network,
        vnKeyId: this.vnKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /** 削除*/
    async showNetworkDel() {
      await this.$confirm("仮想ネットワークを削除します。よろしいですか？");
      await this.$api.virtualNetwork.delete({
        vnCodeList: [this.network.vnCode],
        vnKeyId: this.vnKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
